export default __webpack_public_path__ + "static/media/back_higgs.6081c353.jpg";